import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import styled from 'styled-components'

export const Container = styled.div`
	margin: 0 0;
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		margin: 0 15px;
	}
`

export const CardSection = styled.div`
	margin: 0 0;
`


export const WelcomeHeader = styled.div`
	margin-bottom: 32px;
`

export const WelcomeTitle = styled.h1`
	font-size: 32px;
	font-weight: 800;
	color: #1a1a1a;
	margin: 0 0 8px 0;
	display: inline-block;
	padding: 8px 0px;
`

export const RedirectLink = styled(Link)`
  	color: ${props => props.theme.colors.congressBlue};
	text-decoration: none;
	font-size: 14px;
	font-weight: 500;
	display: flex;
	align-items: center;
	gap: 4px;

	&:hover {
		text-decoration: underline;
	}

	span {
		font-size: 18px;
	}
`

